import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu/menu-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a0011572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-avatar" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-menu"
}, null, -1))
const _hoisted_8 = { class: "menu-avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-menu"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!

  return (_openBlock(), _createBlock(_component_ion_split_pane, { "content-id": "main-content" }, {
    default: _withCtx(() => [
      (_ctx.enableMenu)
        ? (_openBlock(), _createBlock(_component_ion_menu, {
            key: 0,
            "content-id": "main-content",
            type: "reveal"
          }, {
            default: _withCtx(() => [
              (_ctx.isCustomer)
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { id: "inbox-list" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("img", {
                              src: _ctx.profilePhoto,
                              alt: "avatar"
                            }, null, 8, _hoisted_2)
                          ]),
                          _createVNode(_component_ion_list_header, { class: "menu-name" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user?.name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { class: "menu-email" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user?.email), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_3,
                          _hoisted_4,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPages, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              autohide: "false",
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  onClick: ($event: any) => (_ctx.selectedIndex = i),
                                  "router-direction": "root",
                                  "router-link": p.url,
                                  lines: "none",
                                  detail: false,
                                  class: _normalizeClass(["hydrated menu-item", { selected: _ctx.selectedIndex === i }])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_5, [
                                      _createElementVNode("img", {
                                        src: _ctx.selectedIndex === i ? p.iconActive : p.icon,
                                        alt: "icon"
                                      }, null, 8, _hoisted_6),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(p.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isGardener)
                ? (_openBlock(), _createBlock(_component_ion_content, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list, { id: "inbox-list" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", {
                              src: _ctx.profilePhoto,
                              alt: "avatar"
                            }, null, 8, _hoisted_9)
                          ]),
                          _createVNode(_component_ion_list_header, { class: "menu-name" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user?.name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_note, { class: "menu-email" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user?.email), 1)
                            ]),
                            _: 1
                          }),
                          _hoisted_10,
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPagesGardener, (p, i) => {
                            return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                              autohide: "false",
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  onClick: ($event: any) => (_ctx.selectedIndex = i),
                                  "router-direction": "root",
                                  "router-link": p.url ? p.url : false,
                                  lines: "none",
                                  detail: false,
                                  class: _normalizeClass(["hydrated menu-item", { selected: _ctx.selectedIndex === i }])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_12, [
                                      _createElementVNode("img", {
                                        src: _ctx.selectedIndex === i ? p.iconActive : p.icon,
                                        alt: "icon"
                                      }, null, 8, _hoisted_13),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(p.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _hoisted_14
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }))
}